/**
 * Lead — единая точка отправки целей в Яндекс.Метрику.
 * Цели триггерятся только на успешный ответ сервера в соответствующих модулях.
 */
const Lead = {
	// ID счётчика Яндекс.Метрики (см. src/front/modules/head/head.pug)
	counterId: 107006646,

	/**
	 * Отправить цель в метрику.
	 * @param {string} goal — короткое имя цели (application_submit, booking_complete, waitlist_submit)
	 * @param {object} [params] — необязательные параметры визита
	 */
	reachGoal: function(goal, params) {
		try {
			if (typeof window.ym === 'function') {
				if (params) {
					window.ym(this.counterId, 'reachGoal', goal, params);
				} else {
					window.ym(this.counterId, 'reachGoal', goal);
				}
			}
		} catch (e) {
			// Метрика не должна ломать UX
			console.warn('Lead.reachGoal failed:', e);
		}
	}
};

window.Lead = Lead;
